module.exports = __webpack_public_path__ + "static/img/6.35dcacf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/6.png
// module id = FTmG
// module chunks = 0